import { setDataMapping as setDataMappingDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type SetDataMappingProps = ApiMethodBase & {
    field: string;
    mapping: string;
};

export const setDataMapping = ({
    field,
    mapping,
    eventEmitter,
}: SetDataMappingProps) => {
    setDataMappingDiagram(field, mapping);
    eventEmitter.emit(Event.updateDataTransformation);
};
